module.exports = "<span>&copy; {{settings.app.year}} - {{ settings.app.name }}</span>"


//////////////////
// WEBPACK FOOTER
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/layout/footer/footer.component.html
// module id = ../../../../../src/app/layout/footer/footer.component.html
// module chunks = main